import {FETCH_AI_ADDONS, CLEAN_AI_ADDONS} from '../actions/types';

const AI_ADDONS_DEFAULT_STATE = {};

const AiAddonsReducer = (state = AI_ADDONS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_AI_ADDONS:
            return payload;

        case CLEAN_AI_ADDONS:
            return AI_ADDONS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default AiAddonsReducer;
